exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".task[data-v-93c6e364]{border-radius:.25rem;flex-wrap:wrap}.task .task-title[data-v-93c6e364]{height:auto;line-height:1.3em}.task .task-title-input[data-v-93c6e364]{resize:none;overflow:hidden;border-radius:3px 0 0 3px;line-height:1.3em}.task .task-time[data-v-93c6e364]{font-size:.6rem;line-height:1.2em;max-width:60px;white-space:normal}.task .task-checkbox[data-v-93c6e364]{height:23px;width:23px}", ""]);

// exports
